import ProductIdentifierProvider from './hooks/useProductIdentifier';

import { ProductIdentifierProps } from './@types/ProductIdentifierProps';

const ProductIdentifier = (props: ProductIdentifierProps) => (
	<ProductIdentifierProvider {...props}>
		<span
			data-selection={props.componentId}
			className={`product-identifier product-identifier${props.blockClass ? `--${props.blockClass}` : ''} vtex-product-identifier-0-x-product-identifier ${props?.blockClass ? 'vtex-product-identifier-0-x-product-identifier--' + props.blockClass : ''} c-muted-1`}
		>
			<span className="product-identifier__label vtex-product-identifier-0-x-product-identifier__label">
				Referência
			</span>
			<span className="product-identifier__separator vtex-product-identifier-0-x-product-identifier__separator">
				:{' '}
			</span>
			<span className="product-identifier__value vtex-product-identifier-0-x-product-identifier__value">29476</span>
		</span>
	</ProductIdentifierProvider>
);

export default ProductIdentifier;
